import { Activity, Appointment } from '../models/appointment';
import { Tag } from '../models/tag';
import { Person } from '../models/person';

/**
 * Interface para dados de calendário mensal
 */
export interface MonthlyCalendarData {
  firstDay: Date;
  lastDay: Date;
  days: number[];
  tags: MonthlyTagData[];
}

/**
 * Interface para dados de tags mensais
 */
export interface MonthlyTagData {
  tag: string;
  description: string;
  class: string;
}

/**
 * Interface para estado do componente de appointment
 */
export interface AppointmentComponentState {
  person: Person | null;
  selected: Date | null;
  selectedDateMonthly: Date | null;
  selectedDateForModal: string;
  selectedActivityName: string;
  activities: Activity[];
  appointments: Appointment[];
  tags: Tag[];
  currentMonthTags: MonthlyTagData[];
  lastMonthTags: MonthlyTagData[];
  lastTwoMonthTags: MonthlyTagData[];
  lastThreeMonthTags: MonthlyTagData[];
  lastFourMonthTags: MonthlyTagData[];
  lastFiveMonthTags: MonthlyTagData[];
  daysOfMonth: number[];
  daysOfLastMonth: number[];
  daysOfLastTwoMonth: number[];
  daysOfLastThreeMonth: number[];
  daysOfLastFourMonth: number[];
  daysOfLastFiveMonth: number[];
  isLoading: boolean;
  isSavingAppointment: boolean;
  isSavingAbstinence: boolean;
  isSavingVacation: boolean;
}

/**
 * Interface para dados de formulário de appointment
 */
export interface AppointmentFormData {
  id: string;
  personId: string;
  activityId: string;
  description: string;
  justification: string;
  createdAt: Date;
}

/**
 * Interface para dados de formulário de abstinência
 */
export interface AbstinenceFormData {
  id: string;
  personId: string;
  description: string;
  startDate: Date | string;
  endDate: Date | string;
  document?: string;
}

/**
 * Interface para dados de formulário de férias
 */
export interface VacationFormData {
  id: string;
  personId: string;
  startDate: Date | string;
  endDate: Date | string;
  description: string;
  document?: string;
}

/**
 * Interface para configuração de calendário
 */
export interface CalendarConfig {
  monthsToShow: number;
  startFromCurrentMonth: boolean;
  enablePastDates: boolean;
  enableFutureDates: boolean;
}

/**
 * Interface para dados de modal
 */
export interface ModalData {
  id: string;
  title: string;
  content: string;
  size: 'sm' | 'md' | 'lg' | 'xl';
  closable: boolean;
}

/**
 * Interface para validação de formulário
 */
export interface FormValidation {
  field: string;
  isValid: boolean;
  message: string;
  type: 'error' | 'warning' | 'info';
}

/**
 * Interface para dados de filtro
 */
export interface FilterData {
  dateRange: {
    start: Date;
    end: Date;
  };
  personId?: string;
  activityId?: string;
  tagId?: string;
  type?: number;
}
